export default "__VITE_ASSET__f0623c94__"